import { CALL_API } from '../middleware/api'

export const MACHINES_REQUEST = 'MACHINES_REQUEST'
export const MACHINES_SUCCESS = 'MACHINES_SUCCESS'
export const MACHINES_FAILURE = 'MACHINES_FAILURE'

export function fetchMachines(customer) {
  let params = ''

  if (customer !== undefined) {
    params += `&customer=${customer}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `machines?${params}`,
      authenticated: true,
      types: [MACHINES_REQUEST, MACHINES_SUCCESS, MACHINES_FAILURE]
    }
  }
}

export const MACHINE_REQUEST = 'MACHINE_REQUEST'
export const MACHINE_SUCCESS = 'MACHINE_SUCCESS'
export const MACHINE_FAILURE = 'MACHINE_FAILURE'

export function fetchMachine(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `machines/${id}`,
      authenticated: true,
      types: [MACHINE_REQUEST, MACHINE_SUCCESS, MACHINE_FAILURE]
    }
  }
}

export const MACHINE_ADD_REQUEST = 'MACHINE_ADD_REQUEST'
export const MACHINE_ADD_SUCCESS = 'MACHINE_ADD_SUCCESS'
export const MACHINE_ADD_FAILURE = 'MACHINE_ADD_FAILURE'

export function addMachine(machine) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'machines',
      authenticated: true,
      body: JSON.stringify(machine),
      types: [MACHINE_ADD_REQUEST, MACHINE_ADD_SUCCESS, MACHINE_ADD_FAILURE]
    }
  }
}

export const MACHINE_UPDATE_REQUEST = 'MACHINE_UPDATE_REQUEST'
export const MACHINE_UPDATE_SUCCESS = 'MACHINE_UPDATE_SUCCESS'
export const MACHINE_UPDATE_FAILURE = 'MACHINE_UPDATE_FAILURE'

export function updateMachine(id, props) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `machines/${id}`,
      authenticated: true,
      body: JSON.stringify(props),
      types: [MACHINE_UPDATE_REQUEST, MACHINE_UPDATE_SUCCESS,
              MACHINE_UPDATE_FAILURE]
    }
  }
}

export function updateMachineTPV(id, props) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `machines/tpvserial/${id}`,
      authenticated: true,
      body: JSON.stringify(props),
      types: [MACHINE_UPDATE_REQUEST, MACHINE_UPDATE_SUCCESS,
              MACHINE_UPDATE_FAILURE]
    }
  }
}

export const MACHINE_DELETE_REQUEST = 'MACHINE_DELETE_REQUEST'
export const MACHINE_DELETE_SUCCESS = 'MACHINE_DELETE_SUCCESS'
export const MACHINE_DELETE_FAILURE = 'MACHINE_DELETE_FAILURE'

export function deleteMachine(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `machines/${id}`,
      authenticated: true,
      types: [MACHINE_DELETE_REQUEST, MACHINE_DELETE_SUCCESS,
              MACHINE_DELETE_FAILURE]
    }
  }
}

export const MACHINES_RESET = 'MACHINES_RESET'

export function resetMachines() {
  return { type: MACHINES_RESET }
}

export const MACHINE_SECURITY_BOX_DEPOSIT_REQUEST = 'MACHINE_SECURITY_BOX_DEPOSIT_REQUEST'
export const MACHINE_SECURITY_BOX_DEPOSIT_SUCCESS = 'MACHINE_SECURITY_BOX_DEPOSIT_SUCCESS'
export const MACHINE_SECURITY_BOX_DEPOSIT_FAILURE = 'MACHINE_SECURITY_BOX_DEPOSIT_FAILURE'

export function depositSecurityBox(id, props) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `machines/${id}/security-box`,
      authenticated: true,
      body: JSON.stringify(props),
      types: [MACHINE_SECURITY_BOX_DEPOSIT_REQUEST, MACHINE_SECURITY_BOX_DEPOSIT_SUCCESS,
              MACHINE_SECURITY_BOX_DEPOSIT_FAILURE]
    }
  }
}

export const MACHINE_SECURITY_BOX_EMPTY_REQUEST = 'MACHINE_SECURITY_BOX_EMPTY_REQUEST'
export const MACHINE_SECURITY_BOX_EMPTY_SUCCESS = 'MACHINE_SECURITY_BOX_EMPTY_SUCCESS'
export const MACHINE_SECURITY_BOX_EMPTY_FAILURE = 'MACHINE_SECURITY_BOX_EMPTY_FAILURE'

export function emptySecurityBox(id, props) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `machines/${id}/security-box/empty`,
      authenticated: true,
      body: JSON.stringify(props),
      types: [MACHINE_SECURITY_BOX_EMPTY_REQUEST, MACHINE_SECURITY_BOX_EMPTY_SUCCESS,
              MACHINE_SECURITY_BOX_EMPTY_FAILURE]
    }
  }
}

export const MACHINE_DOWNLOAD_REQUEST = 'MACHINE_DOWNLOAD_REQUEST'
export const MACHINE_DOWNLOAD_SUCCESS = 'MACHINE_DOWNLOAD_SUCCESS'
export const MACHINE_DOWNLOAD_FAILURE = 'MACHINE_DOWNLOAD_FAILURE'

export function fetchMachineDownloadCSV() {
  let params = ''
  
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `machines/csv?${params}`,
      authenticated: true,
      types: [MACHINE_DOWNLOAD_REQUEST, MACHINE_DOWNLOAD_SUCCESS, MACHINE_DOWNLOAD_FAILURE]
    }
  }
}
